import { render, staticRenderFns } from "./birthdate.vue?vue&type=template&id=2d2ef884&scoped=true"
import script from "./birthdate.vue?vue&type=script&lang=js"
export * from "./birthdate.vue?vue&type=script&lang=js"
import style0 from "./birthdate.vue?vue&type=style&index=0&id=2d2ef884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ef884",
  null
  
)

export default component.exports